import { Config, Effect } from "effect";
import { kv } from "@vercel/kv";
import { hashRedacted } from "./utils";
import { ConcurrentRateLimiterKvClient } from "../concurrent-rate-limiter/kv-client";
import { ConcurrentRateLimiter } from "../concurrent-rate-limiter";

export function cmcRateLimiter() {
  return Effect.gen(function* () {
    const COIN_MARKET_CAP_KEY = yield* Config.redacted("COIN_MARKET_CAP_KEY");

    const key = `coin-market-cap:rate-limiter:${hashRedacted(
      COIN_MARKET_CAP_KEY
    )}`;

    /**
     * This is specific to Coin Market Cap and may have to become more generic in
     * the future if there are additional external services added that have their
     * own rate-limiting logic.
     */
    const concurrentRateLimiterKvClient = new ConcurrentRateLimiterKvClient({
      kv,
      maxRequests: 30,
      intervalInSeconds: 60,
      key,
    });

    return new ConcurrentRateLimiter(concurrentRateLimiterKvClient);
  });
}
